import { create } from 'zustand';

export type TAuthGateStatus = 'idle' | 'checking' | 'redirecting' | 'error';
export type TAuthMethod = 'google' | 'email';

interface IAuthGateStore {
  status: TAuthGateStatus;
  method: TAuthMethod | null;
  setStatus: (status: TAuthGateStatus) => void;
  setMethod: (method: TAuthMethod | null) => void;
}

export const useAuthGateStore = create<IAuthGateStore>(set => ({
  status: 'idle',
  method: null,
  setStatus: status => set({ status }),
  setMethod: method => set({ method }),
}));
